import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/security/auth.service';

const ALLOWED_ROLES = ['admin', 'analyst'];

/** For the read-only platform pages (statistics, feedbacks) that analysts may view alongside admins. */
export const adminOrAnalystGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // While the app initializes there may be user data but no access token yet;
  // let the JWT interceptor handle refresh, as adminGuard does.
  if (authService.currentUser && ALLOWED_ROLES.includes(authService.currentUser.role)) {
    return true;
  }

  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};
